import React, { useContext, useRef } from 'react';
import { withTheme } from 'styled-components';

import { Context } from '@store/store';
import useClickOutside from '@utils/useClickOutside';

import {
  StyledSettingsDropdown,
  StyledThemeToggleWrapper,
  ButtonsWrapper,
  LightThemeButton,
  YellowThemeButton,
  GrayThemeButton,
  DarkThemeButton,
  StyledToggleSinglePageModeWrapper,
  PageModeButton,
  StyledOldReaderWrapper,
  StyledDivider,
} from './settings-dropdown.styles';

const SettingsDropdown = ({ bookId, theme }) => {
  const [state, dispatch] = useContext(Context);
  const wrapperRef = useRef(null);

  useClickOutside(wrapperRef, 'dropdown');

  return (
    <StyledSettingsDropdown
      isOpened={state.isSettingsDropdownOpened}
      data-is-opened={state.isSettingsDropdownOpened}
      ref={wrapperRef}
    >
      <StyledOldReaderWrapper>
        <a href={`/online/${bookId}`}>Перейти к старой версии просмотрщика</a>
      </StyledOldReaderWrapper>
    </StyledSettingsDropdown>
  );
};

export default withTheme(SettingsDropdown);
